import { generateUserFormGroup } from '@markant-platform/shared/registration';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DefaultLocale } from '@markant-platform/shared/data-access';
import { StaticRole } from '@markant-platform/shared/user/model';
import { SalutationType } from 'data-model';

export type UserFormType = {
  salutation: FormControl<SalutationType | null>;
  firstname: FormControl<string>;
  lastname: FormControl<string>;
  email: FormControl<string>;
};

export type MemberInvitationFormType = {
  language: FormControl<string>;
  position: FormControl<string>;
  department: FormControl<string>;
};

export const USER_FORM: () => FormGroup<UserFormType> = () => generateUserFormGroup();

export const USER_EXTRA_DATA_FORM: () => FormGroup<MemberInvitationFormType> = () =>
  new FormGroup<MemberInvitationFormType>({
    language: new FormControl(DefaultLocale.shorthand, {
      nonNullable: true,
      validators: [Validators.required],
    }),
    position: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required],
    }),
    department: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required],
    }),
  });

export const ORGANIZATION_ROLE_CONTROL: () => FormControl<StaticRole> = () =>
  new FormControl(StaticRole.ORGANIZATION_MEMBER, {
    nonNullable: true,
    validators: [Validators.required],
  });
